import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { LoadingIndicator } from 'common/components/preloader';
import SearchBox from 'help/containers/search_box';
import { v4 } from 'node-uuid';
import FAQs from 'help/containers/faqs';
import { Meta } from 'common/components/meta';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';

export default class HelpHome extends Component {
  constructor(props) {
    super(props);
    this.renderCategory = this.renderCategory.bind(this);
  }

  componentDidMount() {
    this.props.fetchAllCategoriesIfNeeded();
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Help"
      }
    )
    trackMixpanel("Viewed help content", {
      "contentType": "article",
      "pageType": "main index",
      "categorySlug": null,
      "slug": null,
    })
  }

  renderCategory({ title, slug }) {
    return (
      <Link key={v4()} to={`/help/${slug}/`} className="columns category">
        <div className="tile">
          <i className="fa fa-hashtag"/>
          <h3>{ title }</h3>
        </div>
      </Link>);
  }

  render() {
    const { data, isLoading } = this.props;

    if (!data || isLoading) {
      return <LoadingIndicator />;
    }

    const clientCategories = data.filter(({ user_type }) => (user_type === 'client'));
    const creativeCategories = data.filter(({ user_type }) => (user_type === 'creative'));

    return (
      <div>
        <Meta title="Help | crowdspring" />

        <section className="block block-help-search">
          <div className="row align-center">
            <div className="columns medium-12 large-8">
              <SearchBox placeholder="How can we help?" />
            </div>
          </div>
        </section>

        <section className="block block-help-categories">
          <div className="row columns">
            <h2>Clients</h2>
          </div>
          <div className="row small-up-1 medium-up-2 large-up-4">
            { clientCategories.map(this.renderCategory) }
          </div>
        </section>

        <section className="block block-help-categories">
          <div className="row columns">
            <h2>Creatives</h2>
          </div>
          <div className="row small-up-1 medium-up-2 large-up-4">
            { creativeCategories.map(this.renderCategory) }
          </div>
        </section>

        <section className="block block-faq">
          <div className="row align-center">
            <div className="columns medium-10">
              <FAQs />
            </div>
          </div>
        </section>

      </div>);
  }
}

HelpHome.propTypes = {
  fetchAllCategoriesIfNeeded: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  data: PropTypes.array,
};



// WEBPACK FOOTER //
// ./help/components/home.jsx